<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Informasi Transaksi Purchase</strong>
            <div class="card-header-actions">
              <date-range @select="changeDate" />
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  <th>Faktur</th>
                  <th>Supplier</th>
                  <th>Petugas</th>
                  <th>Kode</th>
                  <th>Nama</th>
                  <th>Qty</th>
                  <th>HPP</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody v-if="report.data && report.data.length <= 0">
                <tr>
                  <td colspan="8" class="center">
                    Data tidak ditemukan untuk range tanggal
                    <strong>{{ this.dateRange.startDate.format("DD-MMM-YYYY") }} sd.
                      {{ this.dateRange.endDate.format("DD-MMM-YYYY") }}</strong>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="report.data && report.data.length > 0">
                <tr v-for="(v, k) in report.data" :key="k">
                  <td>
                    <table-number :index="k" :paginate="report.paginate" />
                  </td>
                  <td style="width: 100px">
                    {{ v.created_at | dateTimeFormat }}
                  </td>
                  <td style="width: 120px">{{ v.faktur }}</td>
                  <td style="width: 220px">{{ v.supplier_name }}</td>
                  <td style="width: 70px">{{ v.user_name }}</td>
                  <td v-show="v.details.length <= 0" colspan="3" class="center">
                    -
                  </td>
                  <td v-if="v.details.length == 1" class="center" style="width: 95px">
                    {{ v.details[0].item_code }}
                  </td>
                  <td v-if="v.details.length == 1">
                    {{ v.details[0].item_name }}
                  </td>
                  <td v-if="v.details.length == 1" class="right" style="width: 41px">
                    {{ v.details[0].qty }}
                  </td>
                  <td v-if="v.details.length == 1" class="right" style="width: 90px">
                    {{ v.details[0].hpp | thousandSeparator }}
                  </td>
                  <td v-if="v.details.length == 1" class="right" style="width: 91px">
                    {{ v.details[0].sub_total | thousandSeparator }}
                  </td>
                  <td colspan="5" class="td-parent" v-if="v.details.length > 1">
                    <table style="width: 100%; margin: -1px; border-right: none" class="table table-bordered">
                      <tbody>
                        <tr v-for="(d, ky) in v.details" :key="ky">
                          <td style="width: 95px" class="center">
                            {{ d.item_code }}
                          </td>
                          <td>{{ d.item_name }}</td>
                          <td class="right" style="width: 41px; border-right: none">
                            {{ d.qty }}
                          </td>
                          <td class="right" style="width: 90px; border-right: none">
                            {{ d.hpp | thousandSeparator }}
                          </td>
                          <td class="right" style="width: 90px; border-right: none">
                            {{ d.sub_total | thousandSeparator }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary">
            <i class="cil-print"></i> Print</button>&nbsp;
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i> Excel
          </button>
          <paginator :paginator="report.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber2";
import DateRange from "../../components/DateRange";
import Loader from '../../components/Loader.vue';
import Paginator from '../../components/Paginator.vue';

export default {
  data () {
    return {
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
      startMonth: moment(moment().format("YYYY-MM-") + "01"),
      dateRange: {},
      loading: false
    };
  },
  components: {
    TableNumber,
    DateRange,
    Loader,
    Paginator
  },
  async created () {
    this.dateRange = {
      startDate: moment().subtract(1, 'months'),
      endDate: moment(),
    };
    this.getList(1, "");
  },
  methods: {
    async getList (page, q) {
      this.loading = true
      let dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      HTTPAUTH.get(
        `/api/v1/report-transaction/purchase?page=${page}&size=${this.perPage}&q=${q}${dateRange}`
      ).then((res) => {
        this.report = res.data;
        this.currentPage = page;
        this.total = this.report.paginate.total;
        this.$router.push({
          query: { q: q, page: page, start: startDate, end: endDate },
        });
        this.loading = false
      }).catch(() => {
        this.loading = false
      });
    },
    async changeDate (v) {
      this.dateRange = await this.getDateRange(v)
      await this.getList(1, "");
    },
    changePage (page) {
      let q = '';
      const query = this.$route.query
      if (query && query.q) {
        q = query.q
      }
      this.getList(page, q)
    },
    async getDateRange (v) {
      return {
        startDate: moment(v.startDate),
        endDate: moment(v.endDate),
      }
    },
    async exportExcel () {
      this.loading = true
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      await HTTPExport.post(`/api/v1/trans-report/purchase?${dateRange}`).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
    },
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(pageNext, q);
    },
  },
};
</script>